import { t } from '../../adapters/translate/translate'
import { PasswordHelperContent } from './styles'

type Props = {
  color?: string;
}

const PasswordHelper = ({ color }: Props) => {
  return (
    <PasswordHelperContent color={color}>
      <div dangerouslySetInnerHTML={{ __html: t('PasswordRules') }}></div>
    </PasswordHelperContent>
  )
}

export default PasswordHelper
